import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '~app/BundleProvider';

const ExitLink = () => {
  const t = useT();
  return (
    <Link to="/main">
      <img width="100%" height="100%" src={require("~app/resources/images/icons/x-icon.svg")} alt={t("exit")}/>
    </Link>
  );
};

export default ExitLink;



// WEBPACK FOOTER //
// ./src/components/ExitLink.js